import {} from "react";

import { useValues } from "2g-form/hooks";
import { useZadostiFixniNaroky } from "b2b/api/hooks";

export default function useRezervaceVytvoreniFixniNaroky() {
  const values = useValues() || {};
  const loader = useZadostiFixniNaroky({
    datumOd: values.obdobiOd,
    datumDo: values.obdobiDo,
    zakaznik: values.zakaznik,
    uzivatel: values.uzivatel,
    projekt: values.projekt,
    zdroj: values.zdroj?.zdroj,
    produkt: values.produkt?.produkt
  });
  return {
    visible: Boolean(
      values.zakaznik &&
        values.uzivatel &&
        values.projekt &&
        values.zdroj?.zdroj?.nazevCs &&
        ["VZO", "MZO"].includes(values.zdroj?.zdroj?.nazevCs.toUpperCase()) &&
        values.obdobiOd &&
        values.obdobiDo
    ),
    ...loader,
    data: loader.data || { zadane: "?", povolene: "?" }
  };
}
